import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';

export default function ShowAllData({ sisList, sis}) {
	const sis_info = sisList.find(sis_option => sis_option.sis === sis);
	const sis_name =sis_info.name;
	const sis_email = sis_info.email;
	const sis_phone = sis_info.phone;
	const sis_interface = sis_info.interface;
	const sis_pdf_instructions = sis_info.pdf_instructions;
	const pdf_base_path = `${process.env.PUBLIC_URL || ''}/instruction_pdfs/${sis}`;

	return (
		<div className="documentation-page" data-page='courses'>
			<div className="documentation-step-page">
				<h2 className='documentation-page-heading'>All Data Needed from {sis_name}</h2>
				<div className='documentation-contact-support-container'>
					<img src={require(`../../../../../images/${sis}_logo.jpg`)} alt='sis logo' />
					<div>
						{sis_interface &&
							<>
								<h4>Interface</h4>
								<div>We currently have an interface with {sis_name}. Contact them for more info on how to quickly get your data.</div>
							</>
						}
						{sis_email && 
							<>
							<h4>Email</h4>
							<div>{sis_email}</div>	
							</>
						}
						{sis_phone &&
							<>
								<h4>Phone</h4>
								<div>{sis_phone}</div>
							</>
						}
					</div>
				</div>
				<p>Contact your rep at {sis_name} for more info on how to pull these Excel files. <span className='highlight'>The order of the columns in these files is NOT important.</span></p> 
				<div id='show-all-data-container'>
					<div className='show-all-data-file-container'>
						<div className='show-all-data-heading'>
							<FontAwesomeIcon icon={faFileExcel} className='green-text show-all-data-file-icon'/>
							<strong>Course Data</strong>
						</div>
						<ul>
							<li>Course Code - required</li>
							<li>Course Name - required</li>
							<li>Credits (optional)</li>
							<li>Department (optional)</li>
							<li>Elective/Non-elective (optional)</li>
							<li>Course Length (optional)</li>
							<li>Max Class Size (optional)</li>
							<li>Priority (optional)</li>
						</ul>
						{sis_pdf_instructions.courses &&
							<a  href={`${pdf_base_path}/export_courses_from_${sis}.pdf`} download>Click for exporting courses from {sis_name} (PDF instructions)</a>
						}
					</div>
					<div className='show-all-data-file-container'>
						<div className='show-all-data-heading'>
							<FontAwesomeIcon icon={faFileExcel} className='green-text show-all-data-file-icon'/>
							<strong>Teacher Data</strong>
						</div>
						<ul>
							<li>Teacher ID - required</li>
							<li>Teacher Name (or separated first and last name) - required</li>
							<li>Department (optional)</li>
						</ul>
						{sis_pdf_instructions.teachers &&
							<a  href={`${pdf_base_path}/export_teachers_from_${sis}.pdf`} download>Click for exporting teachers from {sis_name} (PDF instructions)</a>
						}
					</div>
					<div className='show-all-data-file-container'>
						<div className='show-all-data-heading'>
							<FontAwesomeIcon icon={faFileExcel} className='green-text show-all-data-file-icon'/>
							<strong>Previous Sections</strong>
						</div>
						<ul>
							<li>Course Code - required</li>
							<li>Classroom - required</li>
							<li>Course Name (optional)</li>
							<li>Teacher(s) (optional)</li>
						</ul>
						{sis_pdf_instructions.previous_sections &&
							<a  href={`${pdf_base_path}/export_previous_sections_from_${sis}.pdf`} download>Click for exporting previous sections from {sis_name} (PDF instructions)</a>
						}
					</div>
					<div className='show-all-data-file-container'>
						<div className='show-all-data-heading'>
							<FontAwesomeIcon icon={faFileExcel} className='green-text show-all-data-file-icon'/>
							<strong>Student Data</strong>
						</div>
						<ul>
							<li>Student Code - required</li>
							<li>Student Name (or separated first and last name) (optional)</li>
							<li>Grade (optional)</li>
							<li>Gender (optional)</li>
							<li>Has Active IEP? (optional)</li>
							<li>Team (optional)</li>
						</ul>
						{sis_pdf_instructions.students &&
							<a  href={`${pdf_base_path}/export_students_from_${sis}.pdf`} download>Click for exporting student data from {sis_name} (PDF instructions)</a>
						}
					</div>
					<div className='show-all-data-file-container'>
						<div className='show-all-data-heading'>
							<FontAwesomeIcon icon={faFileExcel} className='green-text show-all-data-file-icon'/>
							<strong>Student Requests</strong>
						</div>
						<ul>
							<li>Student Code</li>
							<li>Course Code</li>
							<li>Alternate Course Code (optional)</li>
							<li>Priority (optional)</li>
							<li>Inclusion? (optional)</li>
						</ul>
						{sis_pdf_instructions.student_requests &&
							<a  href={`${pdf_base_path}/export_student_requests_from_${sis}.pdf`} download>Click for exporting student requests from {sis_name} (PDF instructions)</a>
						}
					</div>
				</div>
			</div>
		</div>
	);
}
